import Common from '@/Common/meta/index'
import IView from '@/Common/meta/iview'

export default {
  install(Vue) {
    Common(Vue)
    IView(Vue)
    Vue.prototype.ptw = {
        goods: 260,
        goods_brief: 260,
        retail_price: 120,
        sell_volume: 120,
        goods_unit: 80,
        keywords: 260,
       
    }

  }
}



// WEBPACK FOOTER //
// ./src/meta.js